import APIService from './APIService';

export default {
  documentoExiste(docSlug) {
    return APIService.apiCall().get(`/visualizar-documentacao/documento-existe/${docSlug}`);
  },
  buscarDocumentoFerramenta(docSlug) {
    return APIService.apiCall().get(`/visualizar-documentacao/get-documento-ferramenta/${docSlug}`, {
      responseType: 'blob',
      ...{
        timeout: 60 * 60 * 1000
      }
    });
  }
};
